import React from 'react'
import { Link } from 'react-router-dom';
const FmSection_1 = () => {
    return (
        <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                            Fully Managed AI Agents
                        </h2>
                    </div>
                    <div className="text-wrapper mt-0">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            For Enterprises which need fully managed AI Agents.
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link to="#how-its-works" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="How it works?">How it works?</span>
                        </Link>
                        <Link to="#low-tco" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Low TCO">Low TCO</span>
                        </Link>
                        <Link to="#pricing" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5">
                            <span data-text="Pricing">Pricing</span>
                        </Link>
                        {/* <Link to="#" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4">
                            <span data-text="Customizations">Customizations</span>
                        </Link> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export {FmSection_1}